import React, { Component, Fragment } from 'react';
import Select from 'react-select';
import { Error } from 'components/common/Form.js';
import { areaCodes } from 'components/utils/areaCodes'
import PhoneValidation from 'components/components/auth/utils/CustomerPhoneNumberValidation';
import isWindow from 'components/common/helpers/isWindow';
import TransHelper from 'components/common/translations/TransHelper';

const customStyles = {
  control: () => ({
    background: 'transparent',
    display: 'flex',
  }),
};

class InputPhoneNr extends Component {

  constructor(props) {
    super(props);
    this.state = { hasMounted: false };
  }

  componentDidMount() {
    this.setState({ hasMounted: true });
  }

  validateForm = () => {
    const { phoneCountry, phoneNumber, locale } = this.props
    return new PhoneValidation(phoneCountry.label, phoneNumber, locale).getError();
  }

  handleChangePhoneCountry = (phoneCountry) => {
    this.props.changePhoneCountry(phoneCountry);
  }

  handleChangePhoneNumber = (e) => {
    var value = e.target.value;
    value = value.replace(/\D/g, '');
    this.props.changePhoneNumber(value);
  }

  trans = (key, pref = "content.form") => {
    return TransHelper.translate(this.props.locale, pref + "." + key);
  }

  render() {
    if (!this.state.hasMounted) {
      return null;
    }

    const { phoneCountry, phoneNumber, errorPhone, className } = this.props
    return (
      <Fragment>
        <label htmlFor="phone-number" style={{ paddingBottom: '10px' }}>{this.trans('inputPhoneNumber')}</label>
        <div className="nr-wrap">
          <div>
            <Select
              placeholder={'code'}
              onChange={this.handleChangePhoneCountry}
              options={areaCodes}
              styles={customStyles}
              value={areaCodes.find(({ value, label }) => phoneCountry.label === label)}
              isSearchable
            />
          </div>
          <div>
            <input
              type="tel"
              id="phone-number"
              name="phoneNumber"
              value={phoneNumber}
              onChange={this.handleChangePhoneNumber}
              className={className}
            />
            <Error error={errorPhone} />
          </div>
        </div>
      </Fragment>
    );
  }
}

export default InputPhoneNr;